export default {
  title: 'SMS Templates',

  // Form related
  form: {
    tempName: 'Template Name',
    tempNamePlaceholder: 'Please enter template name',
    country: 'Country',
    countryPlaceholder: 'Please select country',
    category: 'Category',
    categoryPlaceholder: 'Please select category',
    channel: 'Channel',
    channelPlaceholder: 'Please select channel',
    provider: 'Provider',
    providerPlaceholder: 'Please select provider',
    status: 'Status',
    statusPlaceholder: 'Please select status',
    content: 'Template Content',
    contentPlaceholder: 'Please enter template content, supports variables: {username}/{vip_level}/{kyc_name}/{nickname}/{promo_pool_id}/{user_points}/{phone_number}',
    shortChain: 'Short Link',
    shortChainPlaceholder: 'Please enter short link (optional)',
    agentCode: 'Agent Code',
    agentCodePlaceholder: 'Please enter agent code (optional)',
    loginChannel: 'Login Channel',
    loginChannelPlaceholder: 'Please select'
  },

  // Country related
  country: {
    PH: 'Philippines',
    VN: 'Vietnam',
    CN: 'China',
    US: 'United States'
  },

  // Table related
  table: {
    tempName: 'Template Name',
    country: 'Country',
    category: 'Category',
    channel: 'Channel',
    provider: 'Provider',
    content: 'Template Content',
    loginChannel: 'Login Channel',
    status: 'Status',
    actions: 'Actions'
  },

  // Status related
  status: {
    enabled: 'Enabled',
    disabled: 'Disabled'
  },

  // Button related
  button: {
    create: 'Create Template',
    manageCategory: 'Manage Categories',
    test: 'Test Send'
  },

  // Modal related
  modal: {
    createTitle: 'Create SMS Template',
    editTitle: 'Edit SMS Template'
  },

  // Template variables related
  variables: {
    title: 'Supported Template Variables',
    tip: 'Click variables to insert into template content',
    username: 'Username (empty if not available)',
    vipLevel: 'VIP Level (e.g., VIP3)',
    kycName: 'KYC Name (available after verification)',
    nickname: 'Nickname (empty if not available)',
    promoPool: 'Promo Pool (e.g., {promo_pool_7788833399})',
    userPoints: 'User Points Balance (User Points)',
    phoneNumber: 'User Phone Number (desensitized)'
  },

  // Validation related
  validation: {
    tempNameRequired: 'Please enter template name',
    countryRequired: 'Please select country',
    categoryRequired: 'Please select category',
    channelRequired: 'Please select channel',
    providerRequired: 'Please select provider',
    contentRequired: 'Please enter template content',
    statusRequired: 'Please select status'
  },

  // Message related
  message: {
    queryFailed: 'Query failed',
    createSuccess: 'Created successfully',
    createFailed: 'Creation failed',
    updateSuccess: 'Updated successfully',
    updateFailed: 'Update failed',
    deleteSuccess: 'Deleted successfully',
    deleteFailed: 'Deletion failed',
    statusUpdateSuccess: 'Status updated successfully',
    statusUpdateFailed: 'Status update failed'
  },

  // Confirm related
  confirm: {
    delete: 'Are you sure to delete this template?',
    toggleStatus: 'Are you sure to toggle the status of this template?'
  },

  // Pagination related
  pagination: {
    total: 'Total {{total}} records'
  },

  // Test send related
  test: {
    title: 'Test Send SMS',
    templateName: 'Template Name',
    templateContent: 'Template Content',
    inputLabel: 'Recipient',
    inputPlaceholder: 'Please enter phone number or member account',
    inputHint: 'System will automatically identify if you entered a phone number or member account',
    send: 'Send',
    inputRequired: 'Please enter phone number or member account',
    success: 'Test send successful',
    failed: 'Test send failed',
    error: 'Test send error',
    userNotFound: 'Test user is not in our system'
  },

  // Category management related
  category: {
    modal: {
      title: 'Template Category Management'
    },
    table: {
      id: 'ID',
      name: 'Category Name',
      actions: 'Actions'
    },
    form: {
      namePlaceholder: 'Please enter category name'
    },
    button: {
      create: 'Create Category'
    },
    confirm: {
      delete: 'Are you sure to delete this category?',
      deleteDesc: 'This action cannot be undone, please proceed with caution'
    },
    defaultActivity: 'Activity',
    defaultReminder: 'Reminder',
    allCategories: 'All Categories',
    nameRequired: 'Please enter category name',
    nameExists: 'Category name already exists',
    queryFailed: 'Failed to query categories',
    createSuccess: 'Category created successfully',
    createFailed: 'Failed to create category',
    deleteSuccess: 'Category deleted successfully',
    deleteFailed: 'Failed to delete category'
  }
};
